import { HStack, Text, Tooltip } from '@chakra-ui/react'
import { faInfoCircle } from '@fortawesome/pro-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import type { ReactElement } from 'react'

import chakraTokenToVar from '@/utils/chakraTokenToVar'

import { SAT_BOOTCAMP_SCORE_BAND_TO_LABEL } from '@/queries/constants'
import SeriesQ from '@/queries/SeriesQ'
import type { Query } from '@/client/query'
import { SAT_SCORE_BAND_MESSAGE } from '@/client/services/satBootcamp'

export default function SATScoreBand({ series }: { series: Query }): ReactElement {
  const satScoreBand = series(SeriesQ.getScoreBand())
  return (
    <HStack spacing="4px">
      <Text variant="eyebrow-small" color="fg.muted">
        {satScoreBand == null ? null : SAT_BOOTCAMP_SCORE_BAND_TO_LABEL[satScoreBand]} SAT Score
        Range
      </Text>
      <Tooltip label={SAT_SCORE_BAND_MESSAGE}>
        <FontAwesomeIcon icon={faInfoCircle} color={chakraTokenToVar('fg.subtle')} width="12px" />
      </Tooltip>
    </HStack>
  )
}
